// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"585":"a24f271a","712":"b8df0af3","797":"71dca145"}[chunkId] + ".chunk.css";
};